





















import { Component, Mixins } from "vue-property-decorator";
import {
  MenuPane,
} from "../../../../../base/components/panes";
import {
  PageNoDropDownSelector,
} from "../../../../../base/components/system/document";
import {
  ModelEditableMixin,
} from "../../../../../base/components/system/mixins";
import {
  ScaleDropDownSelector,
} from "../../../../../base/components/system/presentation";
import { FormatStructureEditableMixin } from "../mixins";
import { IConfiguration } from "../../../../domain/configuration";

@Component({
  components: {
    MenuPane,
    ScaleDropDownSelector,
    PageNoDropDownSelector,
  },
})
export default class FormatEditMenuContainer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  $configuration!: IConfiguration;

  get shouldShowGrid(): boolean {
    // TODO: 実装.
    return false;
  }

  set shouldShowGrid(value: boolean) {
    // TODO: 実装.
  }

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }
}
